// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Loader_wrapper__vtahI","wrapperFixed":"Loader_wrapperFixed__lqchN Loader_wrapper__vtahI","loader":"Loader_loader__I_9go","spin":"Loader_spin__CfkEm"};